<template>
  <div id="comp-header">
    <div class="wrapper">
      <div class="btn" v-if="btnBack">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          @click="goBack"
        >
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </div>
      <div class="btn" v-if="btnCancel">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <div class="title">{{ headerTitle }}</div>
      <div class="btn" v-if="btnSearch">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </div>
      <div class="btn" v-if="btnMenu" @click="onRightMenuClick">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="1"></circle>
          <circle cx="12" cy="5" r="1"></circle>
          <circle cx="12" cy="19" r="1"></circle>
        </svg>
      </div>
      <div class="btn" v-if="btnEdit" @click="onRightMenuClick">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
          ></path>
          <path
            d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
          ></path>
        </svg>
      </div>
      <div class="btn" v-if="btnClose">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          @click="goBack"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <div class="btn" v-if="btnShare" @click="$emit('share-click')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
          <polyline points="16 6 12 2 8 6"></polyline>
          <line x1="12" y1="2" x2="12" y2="15"></line>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'

export default {
  name: 'CompHeader',
  mixins: [common],
  props: {
    headerTitle: String,
    btnBack: Boolean,
    btnCancel: Boolean,
    btnSearch: Boolean,
    btnMenu: Boolean,
    btnEdit: Boolean,
    btnClose: Boolean,
    btnShare: Boolean
  },
  methods: {
    onRightMenuClick() {
      this.$emit('openLocalMenu')
      this.$EventBus.$emit('open-local-menu')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="../scss/comp-header.scss" scoped></style>
